import { action, makeObservable, observable, computed, runInAction } from 'mobx';

import APIProxy from './APIProxy';
import LoginStore from './LoginStore';

import { isBlank } from './Util';

const blankCredentials = {
    email: '',
    token: '',
    role: '',
    username: '',
    id: '',
}

const INIT = 'init';
const PENDING = 'pending';
const INVALID = 'invalid';
const DONE = 'done';
const ERROR = 'error';

class AppStore {

    state = INIT;

    credentials = blankCredentials;

    currentComponent = null;

    apiProxy = new APIProxy();
    loginStore = new LoginStore({ apiProxy: this.apiProxy });

    menus = [];
    
    socketToken = null;

    constructor() {
        this.setSessionFromStorage();
        this.scheduleAutoLogout(); // Sch

        makeObservable(this, {
            state: observable,
            menus: observable,
            currentComponent: observable,
            credentials: observable,
            logout: action,
            authenticate: action,
            transitionTo: action,
            navigateTo: action,
            isLoading: computed,
            isError: computed,
            isInvalid: computed,
            isHead: computed,
            isMember: computed,
            socketToken: observable,
            otpauthenticate:action,
            generateTokenWithotp:action
            
        });
    }
    scheduleAutoLogout = () => {
        const sessionStart = sessionStorage.getItem('sessionStart');
        const now = new Date().getTime();
        const fiveHours =  1 * 60 * 60 * 1000; 

        if (sessionStart) {
            const elapsed = now - parseInt(sessionStart, 10);
            if (elapsed >= fiveHours) {
                this.logout();
            } else {
                setTimeout(this.logout, fiveHours - elapsed);
            }
        } else if (this.isLoggedIn()) {
            sessionStorage.setItem('sessionStart', now.toString());
            setTimeout(this.logout, fiveHours);
        }
    };

    get isLoading() {
        return this.state === PENDING;
    }

    get isError() {
        return this.state === ERROR;
    }

    get isInvalid() {
        return this.state === INVALID;
    }

    setSessionFromStorage = () => {
        const storedCredentials = sessionStorage.getItem('credentials');

        if (storedCredentials !== null) {
            this.credentials = JSON.parse(storedCredentials);
            this.updateContext();
        }
        else {
            this.credentials = blankCredentials;
            this.updateContext();
        }
    }


    otpauthenticate = async (values) => {
        this.state = PENDING;
        this.credentials = blankCredentials;
        const result = await this.loginStore.originalAuthenticate(values);
        this.state = result.state;
        runInAction(() => {
        if (result.state !== DONE) {
            return;
        }
    });
    }

    generateTokenWithotp = async (values) => {
        const headUserIds = [1, 972];
        this.state = PENDING;
        this.credentials = blankCredentials;
        const result = await this.loginStore.originalAuthenticateWithOTP(values);
        this.state = result.state;
        runInAction(() => {
        if (result.state !== DONE) {
            return;
        }
        debugger;
        const data = JSON.parse(result.data);
          this.credentials.email = data.UserName;
            this.credentials.token = data.UserId;

            if (headUserIds.includes(data.UserId)) {
                this.credentials.role = "head";
            } else {
                this.credentials.role = "member";
            }
           
            this.credentials.username = data.UserName;
            this.credentials.id = data.UserId;

        this.apiProxy.updateCredentialHeaders(this.credentials);

        this.updateContext();
        this.persistCredentials();
    });
    }
   
    authenticate = async (values) => {
  
        this.state = PENDING;
        this.credentials = blankCredentials;

        const result = await this.loginStore.originalAuthenticate(values);

        runInAction(() => {

            this.state = result.state;

            if (result.state !== DONE) {
                return;
            }
           
            const data = result.data;
            this.credentials.email = data.email;
            this.credentials.token = data.id;
            this.credentials.role = data.userType;
            this.credentials.username = data.name;
            this.credentials.id = data.id;
            
            this.apiProxy.updateCredentialHeaders(this.credentials);

            this.updateContext();
            this.persistCredentials();
     
        });
    }

    persistCredentials = () => {
        sessionStorage.setItem('credentials', JSON.stringify(this.credentials));
        sessionStorage.setItem('sessionStart', new Date().getTime().toString()); // Reset session start time
    }

    updateContext = () => {
  
        this.apiProxy.updateCredentialHeaders(this.credentials);
        this.resolveMenu();
        this.resolveLandingPage();
    }

    resolveMenu() {
        if (!this.isLoggedIn()) {
            this.menus = require('./menus/GuestMenu.json');
            return;
        }

        this.menus = require('./menus/DefaultRoleMenu.json');
    }

    resolveLandingPage() {
        for (let menu of this.menus) {
            if (menu.isLandingPage) {
                this.transitionTo(menu.key);
                return;
            }
        }
    }

    navigateTo(index) {
        const menu = this.menus[index];
        this.currentComponent = menu;
    }

    transitionTo(componentkeyName) {
        for (let menu of this.menus) {
            if (menu.key === componentkeyName) {
                this.currentComponent = menu;
                break;
            }
        }
    }

    isLoggedIn = () => {
        return !(isBlank(this.credentials.email))
    }

    logout = () => {
        sessionStorage.removeItem('credentials');
        sessionStorage.removeItem('sessionStart'); // Clear the session timer
        this.credentials = blankCredentials;
        this.updateContext();
        window.location.reload();
    }

    setProxy = (apiProxy) => {
        this.apiProxy = apiProxy;
    }

    get isHead() {
        return this.credentials.role === "head";
    }

    get isMember() {
        return this.credentials.role === "member";
    }
}
export default AppStore;

